module.exports = "/fonts/vendor/iview/dist/styles/ionicons.svg?a2c4a261a239aa84463dc70e4bac9b9a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/iview/dist/styles/fonts/ionicons.svg?v=3.0.0
// module id = 98
// module chunks = 0